export default "__VITE_PUBLIC_ASSET__0df2ced5__"